import React, { Component } from 'react';
import { GameOptions } from "../types";
import RulesPopup from "./rulesPopup";
import OptionsPopup from "./optionsPopup";
// @ts-ignore
import "../css/gameHeader.css";
// @ts-ignore
import "../css/buttons.css";

type SelectOption = 'difficulty' | 'size' | 'height' | 'width';

interface GameHeaderProps {
    startFn: (options: GameOptions) => void,
    undoFn: () => void,
    gameOn: boolean,
}

interface GameHeaderState {
}


class GameHeader extends Component<GameHeaderProps, GameHeaderState> {
    optionsPopup: React.RefObject<OptionsPopup>;

    constructor(props: GameHeaderProps) {
        super(props);
        this.state = {};
        this.optionsPopup = React.createRef();
    }

    render() {
        return (
            <div className="header-panel">
                <div className="header-panel__left">
                    <span className="header-panel__brand">
                        <span className="header-panel__brand-icon">💡</span>
                        Light Up
                    </span>

                    <div className="header-panel__divider" />

                    <button
                        className={'button game-button game-button__start'}
                        onClick={(element) => {
                            const gameOptions = this.gameOptions();
                            if (gameOptions) {
                                this.props.startFn(gameOptions);
                            }
                        }}>
                        <span className="game-button__icon">✨</span>
                        New Game
                    </button>

                    {this.props.gameOn &&
                        <button
                            className={'button game-button game-button__undo'}
                            onClick={(element) => {
                                this.props.undoFn();
                            }}>
                            <span className="game-button__icon">↩️</span>
                            Undo
                            <span className="game-button__shortcut">Z</span>
                        </button>
                    }
                </div>

                <div className="header-panel__right">
                    <OptionsPopup ref={this.optionsPopup} />
                    <RulesPopup />
                </div>
            </div>
        );
    }

    private gameOptions() {
        return this.optionsPopup.current?.getGameOptions();
    }
}

export default GameHeader;